import { Component, OnInit, Input, HostListener, ElementRef, ViewChild } from '@angular/core';
import { UtilServico } from 'src/app/servicos/util.servico';

@Component({
  selector: 'cdk-toolbar-notification',
  templateUrl: './toolbar-notification.component.html',
  styleUrls: ['./toolbar-notification.component.scss']
})
export class ToolbarNotificationComponent implements OnInit {
  cssPrefix = 'toolbar-notification';
  isOpen: boolean = false;
  @Input() notificacoes = [];

  constructor(private utilServico: UtilServico, private elementRef: ElementRef) {}

  ngOnInit() {}

  delete(item) {
    this.utilServico.Delete(`Notificacao/${item.notificacao_id}`).subscribe(
      result => {
        this.notificacoes = this.notificacoes.filter(data => data.notificacao_id !== item.notificacao_id);
      },
      erro => {}
    );
  }
}
